module.exports = __webpack_public_path__ + "img/mendoza.84726db4.jpg";